'use client';

import { eventTracker } from '@/lib/events/cjrEventTracker';
import { CountryGroup } from '@/utils/enums';
import { getLocalStorageValue } from '@/utils/utils';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';

/**
 * Renderless client component that handles:
 * 1. Firing the pageOpen analytics event
 * 2. Redirecting logged-in users to /v2/home
 */
export default function LandingPageClientEffects() {
  const router = useRouter();
  const pathname = usePathname();
  const pageOpenFiredRef = useRef(false);

  // Redirect logged-in users to /v2/home
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (window.location.origin.includes('curiousjr.com')) {
      const _window = window as any;
      if (_window?.PWWebSDK?.accessToken) {
        router.replace(`${window.location.origin}/v2/home`);
        return;
      }
      if (getLocalStorageValue('TOKEN')) {
        router.replace(`${window.location.origin}/v2/home`);
      }
    }
  }, [router]);

  // Fire pageOpen event
  useEffect(() => {
    if (!pageOpenFiredRef.current) {
      pageOpenFiredRef.current = true;
      eventTracker.pageOpen({
        page: 'landing',
        paid_batch_name: [],
        paid_batch_id: [],
        country: ((pathname || '')?.split?.('/')?.[1] || '') as CountryGroup,
      });
    }
  }, [pathname]);

  return null;
}
